import clsx from 'clsx';
import ReactSlider from 'rc-slider';

import 'rc-slider/assets/index.css';

import styles from './styles.module.scss';

type _SliderProps = {
  min: number;
  max: number;
  step?: number;
  disabled?: boolean;
  className?: string;
  marks?: Record<string, string>;
};

export type SliderProps =
  | (_SliderProps & { value?: number; onChange: (value: number) => void })
  | (_SliderProps & { value: [number?, number?]; onChange: (value: [number, number]) => void });

const Slider: React.FC<SliderProps> = (props) => {
  const { min, max, step = 1, value, marks, onChange, disabled, className } = props;

  let _value: number | [number, number];
  if (typeof value === 'number') {
    _value = value;
  } else if (Array.isArray(value)) {
    _value = [value[0] ?? min, value[1] ?? max];
  } else {
    _value = 0;
  }

  return (
    <ReactSlider
      range={Array.isArray(_value)}
      min={min}
      max={max}
      step={step}
      value={_value}
      marks={marks}
      //@ts-ignore
      onChange={onChange}
      disabled={disabled}
      className={clsx(styles.slider, className)}
    />
  );
};

export default Slider;
